import React, { useEffect, useState } from 'react';

import EditWorkspace from '../../components/editWorkspace/EditWorkspace';
import ValidationException from '../../exceptions/ValidationException';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('editWorkspaceBloc');
  const [validationErrors, setValidationErrors] = useState({});
  const [workspace, setWorkspace] = useState();
  const [role, setRole] = useState();

  useEffect(() => {
    const workspaceSub = blocRef.current.workspace$.subscribe(setWorkspace);
    const roleSub = blocRef.current.userRole$.subscribe(setRole);

    return () => {
      workspaceSub.unsubscribe();
      roleSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (data) => {
    try {
      await blocRef.current.updateWorkspace(data);
    } catch (exception) {
      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      }
    }
  };

  const handleChangeIntroduction = () => blocRef.current.openChangeIntroduction();

  return <EditWorkspace role={role} onChangeIntroduction={handleChangeIntroduction} onSubmit={handleSubmit} workspace={workspace} validationErrors={validationErrors} />;
};
